interface Props {
  eyebrow: string;
  title: string;
  subtitle?: string;
  /** "light" for dark backgrounds, "dark" for light backgrounds. */
  tone?: "light" | "dark";
}

/** Shared section header: gold eyebrow, serif title, gold divider. */
const SectionHeading: React.FC<Props> = ({ eyebrow, title, subtitle, tone = "dark" }) => (
  <div className="text-center mb-12">
    <span className="text-brand-500 font-semibold text-xs sm:text-sm uppercase tracking-[0.25em]">
      {eyebrow}
    </span>
    <h2
      className={`font-serif text-3xl sm:text-4xl md:text-[2.75rem] font-bold mt-3 leading-snug ${
        tone === "light" ? "text-white" : "text-navy-900"
      }`}
    >
      {title}
    </h2>
    <div className="w-16 h-[3px] bg-gradient-to-r from-brand-600 to-brand-400 mx-auto mt-5 rounded-full" />
    {subtitle && (
      <p
        className={`mt-5 text-base sm:text-lg max-w-2xl mx-auto ${
          tone === "light" ? "text-navy-200" : "text-navy-900/60"
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
